import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.VendingMachine;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "VendingMachine.Phaser.IntroductionScene.1",
            "VendingMachine.Phaser.IntroductionScene.2",
            "VendingMachine.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/VendingMachine/scenes/GameIntro.ts